/** Post-purchase countdown banner background colors */
export const POST_PURCHASE_BANNER_BACKGROUNDS = Object.freeze({
  blue: "#f0f8ff",
  green: "#e8f8eb",
  red: "#ffebeb",
  yellow: "#fff8e0",
  transparent: "#ffffff",
});

/** Legacy Shopify Banner status → background key */
const LEGACY_BANNER_STATUS_TO_BG = Object.freeze({
  info: "blue",
  default: "blue",
  success: "green",
  warning: "yellow",
  critical: "red",
});

/** Banner / timer text colors (Shopify text tokens) */
export const POST_PURCHASE_TEXT_APPEARANCE_COLORS = Object.freeze({
  default: "#000000",
  info: "#000000",
  success: "#1a7f37",
  warning: "#9a6700",
  critical: "#d1242f",
});

export function normalizeBannerBackground(value) {
  const raw = String(value || "blue").toLowerCase();
  if (Object.prototype.hasOwnProperty.call(POST_PURCHASE_BANNER_BACKGROUNDS, raw)) {
    return raw;
  }
  if (LEGACY_BANNER_STATUS_TO_BG[raw]) {
    return LEGACY_BANNER_STATUS_TO_BG[raw];
  }
  return "blue";
}

export function getBannerBackgroundColor(value) {
  return POST_PURCHASE_BANNER_BACKGROUNDS[normalizeBannerBackground(value)];
}

/** @deprecated use normalizeBannerBackground */
export function normalizeBannerStatus(value) {
  return normalizeBannerBackground(value);
}

export function normalizeTextAppearance(value) {
  const raw = String(value || "default").toLowerCase();
  if (Object.prototype.hasOwnProperty.call(POST_PURCHASE_TEXT_APPEARANCE_COLORS, raw)) {
    return raw === "info" ? "default" : raw;
  }
  return "default";
}

export function getBannerTextColor(value) {
  const key = normalizeTextAppearance(value);
  return POST_PURCHASE_TEXT_APPEARANCE_COLORS[key] || POST_PURCHASE_TEXT_APPEARANCE_COLORS.default;
}
